export default __webpack_public_path__ + "static/media/GPSLocation.abdc26a9.png";